var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 111,
    viewBox: "0 0 110 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_137_166)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 50.5,
    r: 35,
    fill: "#FFBF35"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6062 55.162C64.2723 55.1235 67 51.0635 67 47.5822C67 45.6257 65.614 43.9888 63.7742 43.5933C63.9328 43.143 64.0705 42.7288 64.1627 42.415C64.5745 41.0232 64.3085 39.5532 63.4323 38.3807C62.5387 37.186 61.1725 36.5 59.6827 36.5H46.3162C44.8263 36.5 43.459 37.186 42.5653 38.3807C41.6892 39.5532 41.4232 41.0243 41.835 42.415C41.9283 42.7288 42.0648 43.143 42.2247 43.5945C40.3848 43.99 39 45.6268 39 47.5833C39 51.0647 41.7288 55.1247 49.3938 55.1632C49.4592 55.5155 49.5 55.8748 49.5 56.2412V59.8333C49.5 61.9637 47.708 62.1573 47.1667 62.1667H46C45.3548 62.1667 44.8333 62.6882 44.8333 63.3333C44.8333 63.9785 45.3548 64.5 46 64.5H60C60.6452 64.5 61.1667 63.9785 61.1667 63.3333C61.1667 62.6882 60.6452 62.1667 60 62.1667H58.8427C58.292 62.1573 56.5 61.9637 56.5 59.8333V56.24C56.5 55.8748 56.5408 55.5155 56.6062 55.1632V55.162ZM62.8607 45.8205C62.8805 45.8205 62.8968 45.8322 62.9167 45.8322C63.8815 45.8322 64.6667 46.6173 64.6667 47.5822C64.6667 49.9552 62.7895 52.4787 57.6247 52.7972C57.8825 52.4483 58.1777 52.1252 58.5137 51.8393C60.5425 50.115 61.9355 47.8108 62.8607 45.8205ZM41.3333 47.5822C41.3333 46.6173 42.1185 45.8322 43.0833 45.8322C43.1032 45.8322 43.1195 45.8217 43.1382 45.8205C44.0645 47.8108 45.4575 50.115 47.4863 51.8393C47.8223 52.1252 48.1175 52.4472 48.3753 52.7972C43.2105 52.4787 41.3333 49.9552 41.3333 47.5822ZM50.424 47.889C50.116 47.6767 49.9865 47.2847 50.109 46.93L50.7145 45.0563L49.1208 43.8897C48.7393 43.6097 48.6565 43.0742 48.9365 42.6927C49.0975 42.4733 49.3542 42.3427 49.626 42.3427H51.5872L52.1833 40.4842C52.3338 40.0327 52.8215 39.79 53.273 39.9405C53.5297 40.0257 53.7315 40.2275 53.8167 40.4842L54.4117 42.3427H56.3728C56.8453 42.3427 57.2292 42.7253 57.2292 43.199C57.2292 43.4732 57.0985 43.7298 56.878 43.8908L55.2843 45.0575L55.8898 46.9312C56.0345 47.3815 55.7872 47.8645 55.3357 48.0103C55.0743 48.0943 54.7885 48.0477 54.5668 47.8855L53 46.7328L51.432 47.8843C51.1333 48.1072 50.725 48.1083 50.424 47.889Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_137_166",
    x: 0,
    y: 0.5,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.47451 0 0 0 0 0.309804 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_166"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_137_166",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowBadge);
export default __webpack_public_path__ + "static/media/yellowBadge.62a0f1bcc6fc4d572cb4ea671dc42dfd.svg";
export { ForwardRef as ReactComponent };